export const SITE_ORIGIN = "https://socrattica.web.app";
export const SOCIAL_IMAGE_PATH = "/og-socrattica.png";

export function absoluteUrl(path = "/") {
  return new URL(path, SITE_ORIGIN).toString();
}

export const ORGANIZATION_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": `${SITE_ORIGIN}/#organization`,
  name: "Socrattica",
  url: SITE_ORIGIN,
  logo: absoluteUrl("/logo-2.png"),
  image: absoluteUrl(SOCIAL_IMAGE_PATH),
  founder: {
    "@type": "Person",
    name: "Roberto Román Lázaro",
  },
  sameAs: [
    "https://www.youtube.com/@socrattica",
    "https://open.spotify.com/show/033Vj1gTSHXI1dz2zIZlhx",
  ],
};

export const WEBSITE_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": `${SITE_ORIGIN}/#website`,
  url: SITE_ORIGIN,
  name: "Socrattica",
  description: "Guías digitales y un pódcast para aprender inglés con claridad.",
  publisher: { "@id": `${SITE_ORIGIN}/#organization` },
  inLanguage: "es",
};
